import { render } from "./data-grid.vue?vue&type=template&id=0bd731c6&ts=true"
import script from "./data-grid.vue?vue&type=script&lang=ts"
export * from "./data-grid.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__